import cn from "classnames/bind";
import style from "./pageHeader.module.scss";

export const PageTitle = ({title, extra, small, tiny, ...rest}) => {

    return (
        <>
            <div
                className={cn(style.wrapper, {[style.small]: small, [style.tiny]: tiny})}
                {...rest}
            >
                <div className={cn(style.head_wrapper)}>
                    <div className={cn(style.title)}>
                        {title}
                    </div>

                    <div className={cn(style.extra)}>
                        {extra}
                    </div>
                </div>
            </div>
        </>
    );
}